import React, { Component } from 'react';
import founder from './assets/img/founder.png';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Link
} from 'react-router-dom'
import $ from 'jquery';
import './App.css';
import MainHeader from './components/header';
import MainFooter from './components/Core/footer';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as ReactBootstrap from 'react-bootstrap';

class Home extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {isToggleOn: true, store: this.props.store, fullQual: "undefined", test: "Not Defined", provider: "The TransactionID is "};
    }

    componentWillMount() {
        var globalThis = this;

    }


    render() {
        console.log(ReactBootstrap);
        let redirect = null;
        if (this.state.test !== "Not Defined") {
            redirect = <Redirect to="/login"/>;
        } else {
            redirect =
                <div>
                <MainHeader/>
                    <div id="banner" className="upper">
                        <div className="meal-banner">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-7 col-lg-6 col-lg-offset-1" id="slideDiv"><h3 className="animated slideInLeft text-center" id="textTitle"><strong>Let Us Journey with You!</strong></h3>
                                        <ul className="col-sm-offset-2 col-sm-10 col-xs-12">
                                            <li className="animated slideInRight" id="promise1"><i className="fa fa-check"></i> Modern Scalable Development</li>
                                            <li className="animated slideInLeft" id="promise2"><i className="fa fa-check"></i> Clean Bug Free Code</li>
                                            <li className="animated slideInRight" id="promise3"><i className="fa fa-check"></i> Passionate Dedicated Team</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-5 col-sx-12">

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div>
                        <h2 id="head-banner">You dream, we build.</h2>
                    </div>

                    <div id="main-content" className="container">
                        <h2 className="text-center color-black">How It Works</h2>
                        <ReactBootstrap.Tabs defaultActiveKey={1} animation={false} id="noanim-tab-example">
                            <ReactBootstrap.Tab eventKey={1} title="Plan">
                                <div className="row">
                                    <h2 className="text-center">Dream, Design, Model</h2>
                                    <p className="lead">You have the dream of building a large scale application for your business needs. We make that a reality. First we meet to discuss your business needs and growth plans in order for us to come up with a couple of different models for you to choose from. Then we go with that design and walk you through the process of building your perfect picture.
                                    </p>
                                </div>
                            </ReactBootstrap.Tab>
                            <ReactBootstrap.Tab eventKey={2} title="Tools">
                                <div className="row">
                                    <h2 className="text-center">Skills and Learning</h2>
                                    <p className="lead">React, Angular, Laravel, Node, Github, SourceTree, you name it. We are a team of learners and if there's a good reason for us to build outside of our main knowledge base we are not afraid to get our feet wet. We use open source tools and frameworks to keep the cost down all while driving the performance up.
                                    </p>
                                </div>
                            </ReactBootstrap.Tab>
                            <ReactBootstrap.Tab eventKey={3} title="Experience">
                                <div className="row">
                                    <h2 className="text-center">Sail with Confidence</h2>
                                    <p className="lead">How do you know you are in the right hands? You will have to see for yourself. Before we actually get to kicking off any design or models we will be sure you understand that we are ready to take the battlefield. We have experience building and maintaining complex web applications: Building Restful API's to get the data when you need it. Migrating data from one place to another like encrypting data and pulling CSV files from a remote FTP server and storing it in a database. Writing complex SQL queries to get the data where its needed. Finding solutions for cross browser issues. Tracking customer interaction with your flow. Working with large data sets. Working with a deadline.
                                    </p>
                                </div>
                            </ReactBootstrap.Tab>
                        </ReactBootstrap.Tabs>
                        <div className="col-xs-12 seo-section">
                            <h3>While we are currently based in South Florida, we help clients all over the US with
                                - Web Application Development Port Saint Lucie Florida.
                            </h3>
                            <p><strong>We serve all of St. Lucie county!!!</strong> Although DLaugh - Web Application Development Port Saint Lucie, Florida is where we are based. Locally,
                                we serve large businesses for web application consultations. DLaugh Web Application Engineer Specialist
                                in Palm City Florida, DLaugh Web Application Engineer Specialist in Port St. Lucie Florida or Port Saint Lucie Florida
                                ,DLaugh Web Application Engineer Specialist in Palm Beach Florida, DLaugh Web Application Engineer Specialist in Jensen beach Florida,
                                DLaugh Web Application Engineer Specialist Treasure Coast, DLaugh Web Application Engineer Specialist in Vero Beach Florida,
                                DLaugh Web Application Engineer Specialist in Hobe Sound Florida, DLaugh Web Application Engineer Specialist in Jupiter Florida,
                                DLaugh Web Application Engineer Specialist in Tequesta Florida, DLaugh Web Application Engineer Specialist in Juno Beach Florida,
                                DLaugh Web Application Engineer Specialist in Palm Beach Gardens Florida <br></br>
                                WE SERVICE ALL U.S. BASED LARGE BUSINESSES AND COMPANIES
                            </p>
                        </div>
                        <div className="col-md-12 upper">

                            <hr></hr>
                                <h3 className="text-center">DLaugh - Web Application Engineer Specialist in Port St. Lucie, Florida, helping large businesses everywhere.</h3>
                            <div className="center-image">
                                <img className="img-responsive" id="founder" src={founder} alt="DLaugh Web Application Engineer Specialist founder David Laughlin"/>
                                <br></br>
                            </div>
                                    <p>I’m David Laughlin and I am the founder of DLaugh.com -  Web Application Engineer Specialist in Port St. Lucie, Florida with one simple focus:
                                    </p>
                                    <blockquote><p>"Let my customers Dream about their application, together we will Capture the vision, and our team will Create the best engineered solution for their business. And all together <strong>Providing the best service possible.</strong> My mission is to help my customers absolutely DOMINATE their competitors by outstanding performance, clean code, simple design and effective communication with modern web practices."</p></blockquote>
                        </div>
                    </div>
                    <MainFooter/>
            </div>
        }

        return (
            redirect
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOffers: (offers) => {
            dispatch(toggleTodo(offers))
        },
        setParams: (params) => {
            dispatch(setParams(params))
        }
    }
};

function setParams(params) {
    return { type: "INIT_PARAMS", initParams: params }
}

function toggleTodo(offers) {
    return { type: "SET_OFFERS", offerResponse: offers }
}


const mapStateToProps = state => {
    return {
        state
    }
}

export default Home = connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/App.js